import { QuantifyState } from '@modules/quantify/store/types';
import {
  EmptyWhereClause,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface GetWhereClauseFromCompareQueryOptions {
  query: QuantifyState['query'];
  isFieldA: boolean;
}

export const getWhereClauseFromCompareQuery = ({
  query,
  isFieldA,
}: GetWhereClauseFromCompareQueryOptions): WhereClause => {
  if (query.compareTo?.type !== 'whereClause') {
    return query.whereClauseConfig?.whereClause ?? EmptyWhereClause;
  }

  const compareWhereClause = isFieldA
    ? query.whereClauseConfig?.whereClause
    : query.compareTo.whereClause;

  return compareWhereClause ?? EmptyWhereClause;
};
